import { UPDATE, CREATE } from 'react-admin';
import { methodMap } from './constants';
import { DataProviderPayload, FetchType, TurnRequestInit } from './types';

export const getOptions = (type: FetchType, payload: DataProviderPayload): TurnRequestInit => {
  const headers = new Headers({ Accept: 'application/json' });
  const options: TurnRequestInit = { headers };
  if (payload?.signal) options.signal = payload.signal;

  if (type === UPDATE || type === CREATE || type === 'PATCH') {
    options.method = methodMap[type];

    headers.set('Content-Type', 'application/json');

    const hasData = payload?.data && (typeof payload.data !== 'object' || Object.keys(payload.data).length > 0);

    if (hasData) {
      options.body = JSON.stringify(payload.data);
    } else if (type === CREATE) {
      options.body = '{}';
    }
  }

  return options;
};
